import {
  ContactRoundIcon,
  ExternalLinkIcon,
  HandCoinsIcon,
  HelpCircleIcon,
  LayoutDashboardIcon,
  ScrollTextIcon,
  ShoppingCart,
  StoreIcon,
  TicketIcon,
  Users2Icon,
} from 'lucide-react';

export const sidebarData = {
  navGroups: [
    {
      title: 'Menu',
      items: [
        {
          title: 'Dashboard',
          url: '/backoffice',
          icon: LayoutDashboardIcon,
        },
        {
          title: 'Campanhas',
          url: '/backoffice/campaigns',
          icon: HandCoinsIcon,
        },
        {
          title: 'Faturas',
          url: '/backoffice/invoices',
          icon: ScrollTextIcon,
        },
        {
          title: 'Cupões',
          url: '/backoffice/coupons',
          icon: TicketIcon,
        },
        {
          title: 'Clientes',
          url: '/backoffice/customers',
          icon: ShoppingCart,
        },
      ],
    },
    {
      title: 'Admin',
      items: [
        {
          title: 'Lojas',
          url: '/backoffice/admin/shops',
          icon: StoreIcon,
        },
        {
          title: 'Func. Internos / Lojas',
          url: '/backoffice/admin/eligibility-watchlist',
          icon: ContactRoundIcon,
        },
        {
          title: 'Utilizadores',
          url: '/backoffice/admin/staff',
          icon: Users2Icon,
        },
      ],
    },
    {
      title: 'Outros',
      items: [
        {
          title: 'Centro de Ajuda',
          url: '/backoffice/help-center',
          icon: HelpCircleIcon,
        },
        {
          title: 'Portal de Cliente',
          url: '/portal',
          icon: ExternalLinkIcon,
          external: true,
        },
      ],
    },
  ],
};
